import { IRequesterInfo } from '../../../base/models'
import { ClientProxy } from '../../../base/proxy/clientProxy'
import { IDistrict } from '../models/models'

export class GetDistrictApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'CityTownNeighbourhood/getDistrict',
      requesterInfo,
    })
  }

  public async getDistrict(id: number): Promise<IDistrict[]> {
    this.props.url = `${this.props.url}/${id}`
    return await this.postAsync<IDistrict[]>()
  }
}
